import React, { useEffect } from 'react'

import './App.css';


export const Marquee = ( ) => {

    useEffect(() => {
        const marqueeContainer = document.querySelector('.marquee-container');
        const marqueeContent = document.querySelector('.marquee-content');
    
        // Calculate the width of the text content
        const contentWidth = marqueeContent.offsetWidth;
    
        // Set the animation duration based on the content width
        const animationDuration = (contentWidth / 50) + 10; // You can adjust the speed here
    
        // Apply the animation duration to the marquee content
        marqueeContent.style.animationDuration = `${animationDuration}s`;
      }, []);
    
      
      let msg = "<p style='color:white'><b >RECUERDA: 1. </b> Alista los siguientes documentos para agilizar tu atención en admisión y registro: Documento de Identificación del Paciente Autorización y/o Orden Médica Historia Clínica Dinero: Cuota Moderadora - Copago - Atención Particular "
      msg += " // <b> 2. </b> Entrega los siguientes documentos para mejorar tu atención con el profesional en salud: Historia Clínica Resultados de exámenes o laboratorios anteriores Nombre de los medicamentos y/o tratamientos </p>"
      


    return (

 
        <div className="marquee-container">
            <div className="marquee-content">
            <span dangerouslySetInnerHTML={{ __html: msg }} />
            </div>
        </div>
        );
        
        
  
}